export const VESSEL_MUTATION = `
mutation(
  $id: ID
  $companyId: ID
  $description: I18nFieldInput!
  $i18nLanguage: String
  $name: I18nFieldInput!
  $sizes: [VesselSizeInput]
)
@i18n(
  language: $i18nLanguage
) {
  vessel(
    id: $id
    companyId: $companyId
    description: $description
    name: $name
    sizes: $sizes
  ) {
    id
    company {
      id
      name
    }
    description {
      value
    }
    image {
      url
    }
    name {
      value
    }
    sizes {
      id
      name {
        value
      }
      maxGroupSize
      pricePerHourInCents
    }
  }
}
`
